import { LabelIconToggleButton } from "../../../ui/LabelIconToggleButton";


/**
 * 
 */
export class OptionsLeafPopupTextItem
    extends LabelIconToggleButton
{
    

    public SetWidthGetHeight(width: number): number
    {
        // labelText origin: (0,0.5)
        const height = this.label.displayHeight;

        this.view.setDisplaySize(width, height);

        // set label's offset
        this.labelOffset.setTo(30, height/2);
        // set icon's offset
        // this.iconOffset.setTo(width - 350, height/2);
        this.iconOffset.setTo(-40, height/2);
        this.UpdatePositions();
        return height;
    }
}